import React from 'react';
import { Modal, Button, Card, ListGroup } from 'react-bootstrap';

/**
 * Modal para mostrar observaciones de una Hoja de Trabajo
 * Muestra observación general + observaciones individuales por equipo
 */
const ModalObservacionesHT = ({ show, onHide, ht }) => {
  // Extraer observación general
  const observacionGeneral = ht?.observacion || '';
  
  // Filtrar equipos que tienen observaciones
  const equiposConObservacion = ht?.equipos?.filter(eq => eq.observacion && eq.observacion.trim()) || [];
  
  const tieneObservaciones = observacionGeneral || equiposConObservacion.length > 0;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>
          <i className="bi bi-chat-left-text me-2"></i>
          Observaciones - HT {ht?.numeroOrden}-{ht?.visitas}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {!tieneObservaciones ? (
          <div className="alert alert-info text-center">
            <i className="bi bi-info-circle me-2"></i>
            No hay observaciones registradas para esta Hoja de Trabajo
          </div>
        ) : (
          <>
            {/* Observación General */}
            {observacionGeneral && (
              <Card className="mb-3 w-100">
                <Card.Header className="bg-primary text-white fw-bold w-100">
                  <i className="bi bi-file-text me-2"></i>
                  Observación General
                </Card.Header>
                <Card.Body className='w-100'>
                  <p className="mb-0 white-space-pre-wrap" style={{ whiteSpace: 'pre-wrap' }}>
                    {observacionGeneral}
                  </p>
                </Card.Body>
              </Card>
            )}

            {/* Observaciones por Equipo */}
            {equiposConObservacion.length > 0 && (
              <Card className="mb-3 w-100">
                <Card.Header className="bg-info text-white fw-bold w-100">
                  <i className="bi bi-list-ul me-2"></i>
                  Observaciones por Equipo ({equiposConObservacion.length})
                </Card.Header>
                <ListGroup variant="flush">
                  {equiposConObservacion.map((eq, index) => {
                    // Usar snapshot si existe (optimización spec 003), sino usar equipo poblado
                    const itemNombre = eq.snapshot?.item || eq.equipo?.item?.nombre || 'N/A';
                    const consecutivo = eq.consecutivo || 'N/A';
                    const marca = eq.snapshot?.marca || eq.equipo?.marca || '';
                    const modelo = eq.snapshot?.modelo || eq.equipo?.modelo || '';
                    const serie = eq.snapshot?.serial || eq.equipo?.serie || '';
                    
                    return (
                      <ListGroup.Item key={eq._id || index}>
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1">
                            <div className="fw-bold text-primary mb-1">
                              {itemNombre} - Consecutivo: {consecutivo}
                            </div>
                            {(marca || modelo || serie) && (
                              <div className="text-muted small mb-2">
                                {marca && `Marca: ${marca}`}
                                {marca && modelo && ' | '}
                                {modelo && `Modelo: ${modelo}`}
                                {(marca || modelo) && serie && ' | '}
                                {serie && `Serie: ${serie}`}
                              </div>
                            )}
                            <div className="border-start border-3 border-warning ps-3 py-2 bg-light">
                              <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                {eq.observacion}
                              </p>
                            </div>
                          </div>
                        </div>
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              </Card>
            )}
          </>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalObservacionesHT;
